exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TrialLandingPage-1c64228b{max-width:700px;margin:80px auto}\n", ""]);

// Exports
exports.locals = {
	"TrialLandingPage": "TrialLandingPage-1c64228b"
};